module.exports = __webpack_public_path__ + "img/anime-logo.7d347e9f.jpg";